
export * from './pages'

import 'bootbox'
import * as _ from 'lodash'


if (!DEBUG) {
    console.log('')
    console.log('%cHold Up!', 'font-size: 20px; font-weight: bold;')
    console.log('%cIf someone told you to copy/paste something here you have an 11/10 chance you\'re being scammed.', 'font-size: 14px;')
    console.log('%cPasting anything in here could give attackers access to your bank accounts data.', 'color: red; font-size: 14px;')
    console.log('%cUnless you understand exactly what you are doing, close this window and stay safe.', 'font-size: 14px;')
    console.log('')
}


import i18next from './i18n'
window['i18n'] = i18next

if (helpers.appSettingsGet('privacyMode') !== null)
    globals.vars.privacyMode = true

$(".change-lang").each(function() {
    $(this).off().on('click', function(e) {
        const lng = $(this).attr('data-value')

        const params = { lang: lng }

        helpers.updateProfile(params, true)         
    })
})


$( document ).ready(function() {
    const appReady = new Event("appReady")

    if (/^\/(auth|webauthn|signup|enroll|recover)/.test(window.location.pathname))
        return document.dispatchEvent(appReady)

    $.ajax({
        url: '/json/user-data',
        method: 'POST',
        data: { _csrf: $("meta[name=_csrf]").attr("content") },
        success: function (response) {  
            if (DEBUG) console.log(response)

            Object.assign(globals.vars.userData, response)

            for (let i=0; i<globals.vars.userData.accounts.length; i++) {
                const account = globals.vars.userData.accounts[i]
                globals.vars.userData.accountsById[account['_id']] = account
            }

            for (let i=0; i<globals.vars.userData.categories.length; i++) {
                const cat = globals.vars.userData.categories[i]
                globals.vars.userData.categoriesById[cat['_id']] = cat
            }

            document.dispatchEvent(appReady)
        },
        error: function (err) {
            console.log(err)
        }
    })

    $('.left-side-menu').removeClass('visually-hidden')
})




